export default "__VITE_ASSET__2d44540f__"